import { redirect } from '@tanstack/react-router';

import { getRuntimeConfig } from '@/lib/runtime-config.js';

/**
 * Route guard: if an admin has disabled the Dashboards section (runtime config
 * `features.dashboards === false`), redirect away from any `/dashboards*` route
 * (covers deep-links / bookmarks, not just the hidden nav entry). Fail-open — the
 * config loader defaults the flag to `true`, so a config blip leaves it accessible.
 */
export function ensureDashboardsEnabled(): void {
  if (!getRuntimeConfig().features.dashboards) {
    throw redirect({ to: '/' });
  }
}
